import { gettext } from '@adjust/dashboard-core/lib/utils/localization';

let platforms = [
  gettext('android'),
  gettext('bada'),
  gettext('blackberry'),
  gettext('ios'),
  gettext('linux'),
  gettext('macos'),
  gettext('server'),
  gettext('symbian'),
  gettext('webos'),
  gettext('windows'),
  gettext('windows-phone'),
  gettext('unknown')
];

export { platforms };
